export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -72, duration: 1.2 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};

export const goToSection = (id, pathname, navigate) => {
  if (pathname !== "/") {
    navigate(`/#${id}`);
  } else {
    scrollToId(id);
  }
};
